<div class="auth-page">
  <div class="auth-card">
    <h1 class="auth-title">Forgot password</h1>

    <ng-container *ngIf="!submitted; else successPanel">
      <p class="auth-intro">Enter the email address you signed up with and we'll send you a link to reset your password.</p>

      <ng-container *ngIf="!loading; else loadingPanel">
        <div class="field-group">
          <label class="field-label">Email address</label>
          <mat-form-field appearance="outline" class="full-width">
            <input matInput required name="email" type="email" autocomplete="email"
                   [formControl]="emailControl" (keyup.enter)="submit()" />
            <mat-error *ngIf="emailControl.hasError('required')">Email is <strong>required</strong></mat-error>
            <mat-error *ngIf="!emailControl.hasError('required') && emailControl.hasError('email')">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>
        </div>

        <button class="primary-btn" type="button" (click)="submit()">Send reset link</button>

        <p class="auth-footer">
          Remembered it? <a class="auth-link" (click)="backToSignIn()">Back to sign in</a>
        </p>
      </ng-container>
    </ng-container>

    <ng-template #successPanel>
      <p class="auth-confirmation">{{ confirmationMessage }}</p>
      <button class="primary-btn" type="button" (click)="backToSignIn()">Back to sign in</button>
    </ng-template>

    <ng-template #loadingPanel>
      <div class="loading-container">
        <mat-progress-spinner class="loading-spinner" color="accent" mode="indeterminate"></mat-progress-spinner>
      </div>
    </ng-template>
  </div>
</div>
